import styled from "@emotion/styled";
import { colors } from "../../../styles/colors";
import { fonts } from "../../../styles/fonts";

export const FAQWrap = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 830px;
  @media (max-width: 769px) {
    margin-top: 30px;
    width: auto;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  line-height: 42px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  margin-top: 60px;
  @media (max-width: 769px) {
    margin-top: 10px;
    font-size: 36px;
    line-height: 42px;
  }
`;

export const AccordionItem = styled.div`
  overflow: hidden;
  height: auto;
  padding-right: 50px;
  max-height: ${(props) => (props.isOpen ? 0 : "9999px")};
  transition: ${(props) =>
    props.isOpen ? "max-height 0.35s cubic-bezier(0, 1, 0, 1)" : "max-height 0.3s cubic-bezier(1, 0, 1, 0)"};
`;

export const ItemTitle = styled.h3`
  font-size: 16px;
  line-height: 25px;
  margin-bottom: 0;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.latoBold};
`;

export const TitleWrapper = styled.div`
  cursor: pointer;
  fill: ${colors.RED};
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 14px;
  margin-bottom: 18px;
  svg.icon {
    stroke: ${colors.RED};
    margin-top: 6px;
  }
`;

export const Text = styled.p`
  color: ${colors.GREY_SEMIDARK};
  font-family: ${fonts.latoRegular};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 27px;
  margin: 0 0 20px;
  line-height: 1.375;
`;

export const Separator = styled.div`
  background: ${colors.GREY_LIGHT};
  height: 1px;
`;

export const Link = styled.a`
  color: ${colors.RED};
  text-decoration: underline;
`;
export const Footer = styled.div`
  color: ${colors.GREY_DARK};
  font-family: ${fonts.latoRegular};
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  width: 390px;
  margin-top: 20px;
  @media (max-width: 769px) {
    font-size: 16px;
  }
`;
